import { InjectionToken } from '@angular/core';

import type { GridRow } from './grid-row.type';

/** Optional host hook invoked when new rows are loaded (e.g. map coordinate registration). */
export interface GridRowObserver {
  onRowsLoaded(rows: ReadonlyArray<GridRow>): void;
}

export const GRID_ROW_OBSERVER: InjectionToken<GridRowObserver> = new InjectionToken<GridRowObserver>(
  'GRID_ROW_OBSERVER'
);
